module.exports = __webpack_public_path__ + "img/focus-on-banner.1a019f1d.png";